const pagesTitles = {
  adminsManagement: "إدارة المسؤولين",
  admins: "قائمة المسؤولين",
  adminsAdd: "إضافة مسؤول جديد",
  adminsEdit: "تعديل مسؤول",
};

export default pagesTitles;
